import { api } from './api';
import {
  PlantSource,
  CreatePlantSourceInput,
  UpdatePlantSourceInput,
  PlantSourceSearchParams,
  PlantSourceListResponse,
  PlantSourceQRCodeResponse,
} from '../types/plantSource';
import { ApiResponse } from '../types/plant';

export const plantSourceApi = {
  // Plant source operations
  createPlantSource: async (sourceData: CreatePlantSourceInput): Promise<PlantSource> => {
    const response = await api.post<ApiResponse<PlantSource>>('/sources', sourceData);
    if (!response.data.success || !response.data.data) {
      throw new Error(response.data.error || 'Failed to create plant source');
    }
    return response.data.data;
  },

  getPlantSources: async (params?: PlantSourceSearchParams): Promise<PlantSourceListResponse> => {
    const response = await api.get<ApiResponse<PlantSourceListResponse>>('/sources', { params });
    if (!response.data.success || !response.data.data) {
      throw new Error(response.data.error || 'Failed to fetch plant sources');
    }
    return response.data.data;
  },

  getPlantSource: async (id: string): Promise<PlantSource> => {
    const response = await api.get<ApiResponse<PlantSource>>(`/sources/${id}`);
    if (!response.data.success || !response.data.data) {
      throw new Error(response.data.error || 'Failed to fetch plant source');
    }
    return response.data.data;
  },

  updatePlantSource: async (id: string, updates: UpdatePlantSourceInput): Promise<PlantSource> => {
    const response = await api.put<ApiResponse<PlantSource>>(`/sources/${id}`, updates);
    if (!response.data.success || !response.data.data) {
      throw new Error(response.data.error || 'Failed to update plant source');
    }
    return response.data.data;
  },

  deletePlantSource: async (id: string): Promise<void> => {
    const response = await api.delete<ApiResponse<{ message: string }>>(`/sources/${id}`);
    if (!response.data.success) {
      throw new Error(response.data.error || 'Failed to delete plant source');
    }
  },

  // QR Code operations
  generateQRCode: async (sourceId: string): Promise<PlantSourceQRCodeResponse> => {
    const response = await api.post<ApiResponse<PlantSourceQRCodeResponse>>(
      `/sources/${sourceId}/qrcode`
    );
    if (!response.data.success || !response.data.data) {
      throw new Error(response.data.error || 'Failed to generate QR code');
    }
    return response.data.data;
  },

  // Public plant source view operations
  getPlantSourceByQrCode: async (qrCodeId: string): Promise<PlantSource> => {
    const response = await api.get<ApiResponse<PlantSource>>(`/sources/public/${qrCodeId}`);
    if (!response.data.success || !response.data.data) {
      throw new Error(response.data.error || 'Failed to fetch plant source');
    }
    return response.data.data;
  },
};
